export function dirname(path: string): string {
  const parts = path.split(/[/\\]/g);
  if (parts.length >= 1) {
    return parts.slice(0, parts.length - 1).join("/");
  } else {
    throw new Error(`dirname: bad argument: ${path}`);
  }
}
